import React, { useState, useEffect, Fragment } from 'react';
import ScoreIcon from "assets/images/images_new/pie-chart-icon.svg";
import ReactHtmlParser from "react-html-parser";
import Sound from 'react-sound';
import { s3base } from 'api.js';
import Content from "/public/images/popup-icons/Content.png";
import Score from "/public/images/popup-icons/Score-icon.png";
import Pronunciation from "/public/images/popup-icons/pronoun.png";
import Fluency from "/public/images/popup-icons/checkboxGreen.png";
import BarFrequency from "/public/images/popup-icons/popupBar.png";
import Grammar from "/public/images/popup-icons/Grammar.png";
import Vocabulary from "/public/images/popup-icons/Vocabulary.png";
import FormIcon from "/public/images/popup-icons/Form.png";
import listenAudioImage from "assets/images/images_new/audio-icon.png";

export default function WriteFromDictationResult(props) {
	const [result, setResult] = useState(null);
	const [audioUrl, setAudioUrl] = useState(null);
	const [audioPlaying, setAudioPlaying] = useState(false);
	const [soundStatus, setSoundStatus] = useState(Sound.status.STOPPED);

	useEffect(() => {
		const { resultData } = props;
		console.log("WriteFromDictationResult props:", props);
		console.log("Script:", props.script);
		console.log("QuestionAudios:", props.questionAudios);
		
		setResult(resultData);
	}, [props.resultData]);

	// Set up audio URL when questionAudios or mediaLink prop changes
	useEffect(() => {
		let audioFile = null;
		
		// First try question_audios if available
		if (props.questionAudios && props.questionAudios.length > 0) {
			audioFile = props.questionAudios[0].value;
		}
		// Fallback to media_link (this is the main audio source used in practice)
		else if (props.mediaLink) {
			audioFile = props.mediaLink;
		}
		
		if (audioFile) {
			const fullAudioUrl = audioFile.startsWith('http') 
				? audioFile 
				: `${s3base}${audioFile}`;
			setAudioUrl(fullAudioUrl);
		}
	}, [props.questionAudios, props.mediaLink]);

	// Set up audio URL when questionAudios or mediaLink prop changes
useEffect(() => {
    // Reset audio state first
    setSoundStatus(Sound.status.STOPPED);
    setAudioPlaying(false);
    setAudioUrl(null);
    
    let audioFile = null;
    
    // First try question_audios if available
    if (props.questionAudios && props.questionAudios.length > 0) {
        audioFile = props.questionAudios[0].value;
    }
    // Fallback to media_link (this is the main audio source used in practice)
    else if (props.mediaLink) {
        audioFile = props.mediaLink;
    }
    
    if (audioFile) {
        const fullAudioUrl = audioFile.startsWith('http') 
            ? audioFile 
            : `${s3base}${audioFile}`;
        setAudioUrl(fullAudioUrl);
    }
}, [props.questionAudios, props.mediaLink, props.script]);

	const validKeys = [
		"score",
		"content",
		"form",
		"grammar", // Write Essay Only.
		"grammer", // Summarize Written Text only.
		"vocabulary",
		"linguistic",
		"structure",
		"spelling"
	];

	const ICON_MAP = {
		content: Content,
		score: Score,
		fluency: Fluency,
		pronunciation: Pronunciation,
		overall: BarFrequency,
		grammar: Grammar,
		form: FormIcon,
		vocabulary: Vocabulary,
	};

	const getIconByType = (type) => {
		return ICON_MAP[type?.toLowerCase()] || "";
	};	

	const scoreClass = (score) => {
		let class_name = "color-danger";

		if (score > 30 && score <= 60) {
			class_name = "color-warning";
		} else if (score > 60) {
			class_name = "color-success";
		}

		return class_name;
	}

	const userResponseHtml = (str) => {
		const result = str.split("<br/>");
		return ReactHtmlParser(result[0].trim());
	}

	const missedWordsHtml = (str) => {
		const result = str.split("<br/>");
		const missed_words = result[1].split(",");

		return ReactHtmlParser(missed_words.join(", "));
	}

	// Audio control functions
	const playPauseButton = () => {
		setSoundStatus(audioPlaying ? Sound.status.PAUSED : Sound.status.PLAYING);
		setAudioPlaying(!audioPlaying);
	};

	const finishStopped = () => {
		setSoundStatus(Sound.status.STOPPED);
		setAudioPlaying(false);
	};

	const audioLoaded = (obj) => {
		if (obj.loaded) {
			// Audio is ready to play
		}
	};
	const score = result?.score?.score

	const outOf = result?.score?.out_of;
	
	const percent = outOf ? (score / outOf) * 100 : 0;

	return (
		<>
			{(result !== null && props.showMainContent) &&
				<div className="">
					<div className="">
						<div className="">
							{/* <div className='gab-text size-adjust'>
								<h3 className='title'>Score info</h3>
								<div className='words mb-3'>
									{props.newResult !== null && props.newResult !== undefined && 'html' in props.newResult &&
										userResponseHtml(props.newResult.html)
									}
								</div>
								<h3 className='correct-sentence mb-3'>Correct Sentence: {props.script}</h3>
								<div className='words'>
									{props.newResult !== null && props.newResult !== undefined && 'html' in props.newResult &&
										missedWordsHtml(props.newResult.html)
									}
								</div>
							</div>
							<div className='result-score-row result-row'>
								<div className='score-content'>
									<div className='score-circle-content'>
										<div className='score-circle'></div>
										<div className='score-circle-text'>
											<p>{props.subcategoryId !== 20 ? "Overall" : ""} Score</p>
											{props.subcategoryId !== 20 ? (
												<h2>{result.overall.score}/{result.overall.out_of}</h2>
											) : (
												<h2>{result.score.score}/{result.score.out_of}</h2>
											)}
										</div>
									</div>
								</div>
							</div>	*/}
						</div>
					</div>
						<div className='card popup-border p-4 mb-4' >
							<div className="row align-items-center">

							{/* LEFT */}
							<div className="col-12 text-center text-lg-start mb-4 mb-lg-0">

								<div className="d-flex flex-column flex-sm-row align-items-center gap-3 gap-sm-4 mb-3">
								{/* <div className="score-circle-modern">
									{props.subcategoryId !== 20
									? `${result?.overall?.score}/${result?.overall?.out_of}`
									: `${result?.score?.score}/${result?.score?.out_of}`}
								</div> */}
								 <div className="score-circle-modern" style={{ "--progress": `${percent}%` }}>
									<span>{score}/{outOf}</span>
								</div>

								<h6 className="result-score mb-0">Overall Score</h6>
								</div>
							</div>

							{/* RIGHT */}
							<div className="col-12">
							<div className="row g-3">

								{Object.keys(result.score).map((item, i) => {
								if (validKeys.includes(item)) {
									return (
									<div key={i} className="col-12 col-md-6">

										<div className="score-card-item d-flex justify-content-between align-items-center h-100 p-3 list-score-detail-border">

										<div className="d-flex align-items-center gap-2">
											<img
											src={getIconByType(item)}
											alt={result[item]?.label}
											className="img-fluid"
											style={{ width: "28px" }}
											/>
											<span className="label-text">
											{result[item]?.label}
											</span>
										</div>

										<strong className="label-score">
											{result[item]?.score}/{result[item]?.out_of}
										</strong>

										</div>

									</div>
									);
								}
								return null;
								})}

							</div>
							</div>

							</div>
						</div>
						
						{/* Audio Script Section - Simple like Audio Transcript */}
						
						
						<div className='gab-card result-content mb-3'>
							<div className='gab-text size-adjust mt-0'>
							<div className="AIScoreCom__Category-sc-1yzm0aw-12 liAXDW d-flex flex-wrap gap-1 gap-md-2 justify-content-md-end">
								<div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca">
								<div className="AIScoreCom__Circle-sc-1yzm0aw-10 iyKrJgd"></div>
								<span className="score-color" >Correct words</span>
								</div>
								{/* <div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca">
								<div className="AIScoreCom__Circle-sc-1yzm0aw-10 iyKrJav"></div>
								<span className="score-color" >Average</span>
								</div> */}
								<div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca">
								<div className="AIScoreCom__Circle-sc-1yzm0aw-10 iyKrJbad"></div>
								<span className="score-color" >Wrong words</span>
								</div>        
							</div>
								{props.newHtml !== null &&
									<>
										{/* {props.renderResponseHtml(props.newHtml)} */}
										{userResponseHtml(props.newResult.html)}
									</>
								}

								{props.newResult !== null && props.newResult !== undefined && 'html' in props.newResult &&
									userResponseHtml(props.newResult.html)
								}
							</div>
							
						</div>
						{props.newResult !== null && props.newResult !== undefined && 'html' in props.newResult &&
						
								<div className="audio-transcript-text visibility-visible line-height-adjust mb-3">
									<p className="mb-0"><strong className="audio-label">Missing Words :</strong></p>
										{missedWordsHtml(props.newResult.html)}
								</div>
							
						}
						{props.script && (
							<div className="audio-transcript-text visibility-visible line-height-adjust mb-3">
								<p className="mb-0"><strong className="audio-label">Correct Answer :</strong></p>
								{props.script.split(" ").map((item, i) => (
									<React.Fragment key={i}>
										<span className="word">{item}</span>
										<i> </i>
									</React.Fragment>
								))}
								{audioUrl && (
									<button
										className="audio-btn"
										onClick={playPauseButton}
									>
										{!audioPlaying ? (
											<i className="fa fa-play"></i>
										) : (
											<i className="fa fa-stop"></i>
										)}
									</button>
								)}
							</div>
						)}

				</div>
			}
			<div className="pull-left">
				{props.moreDetails}
			</div>
			
			{/* Hidden Sound Component */}
			{audioUrl && (
				<div style={{ display: 'none' }}>
					<Sound
						url={audioUrl}
						onLoad={audioLoaded}
						playStatus={soundStatus}
						onFinishedPlaying={finishStopped}
					/>
				</div>
			)}
		</>
	);
};